// Auth UI Text Constants

export const AUTH_UI_TEXT = {
  // Login Screen
  LOGIN_TITLE: 'Welcome!',
  LOGIN_NEW_USER: 'New User?',
  LOGIN_CREATE_ACCOUNT: 'Create Account',
  LOGIN_EMAIL_LABEL: 'Work Email',
  LOGIN_PASSWORD_LABEL: 'Password',
  LOGIN_FORGOT_PASSWORD: 'Forgot Password?',
  LOGIN_BUTTON: 'Login',
  LOGIN_OR_TEXT: 'Or Login With',
  LOGIN_SUCCESS: 'Login successful!',
  LOGIN_LOGGED_IN_TITLE: '✓ Login Successful',
  LOGIN_LOGGED_IN_MESSAGE: 'You have successfully logged in',

  // SignUp Screen
  SIGNUP_TITLE: 'Create Account for Free',
  SIGNUP_EXISTING_USER: 'Existing User?',
  SIGNUP_SIGN_IN: 'Sign In',
  SIGNUP_FIRST_NAME_LABEL: 'First Name',
  SIGNUP_LAST_NAME_LABEL: 'Last Name',
  SIGNUP_EMAIL_LABEL: 'Work Email',
  SIGNUP_PASSWORD_LABEL: 'Password',
  SIGNUP_CONFIRM_PASSWORD_LABEL: 'Confirm Password',
  SIGNUP_BUTTON: 'Get Started for Free',
  SIGNUP_TERMS_PREFIX: 'By creating an account, you agree to our',
  SIGNUP_TERMS_LINK: 'Terms and Conditions',
  SIGNUP_TERMS_MIDDLE: '. You also agree to receive emails regarding your tax return status, IRS notifications, and upcoming deadlines from Tax1099. Read our',
  SIGNUP_PRIVACY_LINK: 'Privacy Policy',

  // OTP Screen
  OTP_TITLE: 'Verify OTP',
  OTP_DESCRIPTION: "We've sent a 6-digit verification code to",
  OTP_BUTTON: 'Verify',
  OTP_RESEND_TEXT: "Didn't receive the code?",
  OTP_RESEND_IN: 'Resend in',
  OTP_RESEND_SECONDS: 's',
  OTP_RESEND_LINK: 'Resend Code',
  OTP_RESENDING: 'Sending...',
  OTP_BACK_TO_SIGNUP: '← Back to SignUp',
  OTP_SUCCESS: 'OTP code has been resent to your email',

  // TFA Screen
  TFA_TITLE: 'Two-Factor Authentication',
  TFA_DESCRIPTION: 'Enter the 6-digit code from your authenticator app',
  TFA_BUTTON: 'Verify',
  TFA_HELP_TEXT: "Can't access your authenticator app? Contact support for assistance.",
  TFA_BACK_TO_SIGNUP: '← Back to SignUp',

  // Validation Messages
  VALIDATION_EMAIL_INVALID: 'Invalid email.',
  VALIDATION_PASSWORDS_NO_MATCH: 'Passwords do not match.',
  VALIDATION_REQUIRED_FIELD: 'This field is required',

  // Error Messages
  ERROR_USER_NOT_FOUND: 'User not found',
  ERROR_INCORRECT_PASSWORD: 'Incorrect Password',
  ERROR_ACCOUNT_LOCKED: 'Account locked due to multiple failed login attempts. Please reset your password or contact support.',
  ERROR_INVALID_CREDENTIALS: 'User not found or invalid credentials',
  ERROR_SOMETHING_WRONG: 'Something went wrong',
  ERROR_AUTH_FAILED: 'Authentication failed. Please try again.',
  ERROR_AUTH_RESPONSE: 'Error processing authentication response',
  ERROR_INVALID_OTP: 'Invalid OTP code',
  ERROR_OTP_VERIFICATION_FAILED: 'OTP verification failed',
  ERROR_OTP_RESEND_FAILED: 'Failed to resend OTP',
  ERROR_INVALID_TFA: 'Invalid 2FA code',
  ERROR_TFA_VERIFICATION_FAILED: '2FA verification failed',

  // Success Messages
  SUCCESS_OTP_SENT: 'Please enter the 6-digit OTP sent to your email',
  SUCCESS_TFA_PROMPT: 'Please enter the 6-digit code from your authenticator app',
  SUCCESS_AUTH_PROCESSING: 'Authentication successful!',
  
  // Signup Success Messages
  SIGNUP_SUCCESS_TITLE: 'Account Created Successfully!',
  SIGNUP_SUCCESS_WELCOME: 'Welcome! We are thrilled to have you here.',
  SIGNUP_SUCCESS_MESSAGE: 'Your account has been created successfully. Click the button below to continue to the main website and login.',
  SIGNUP_SUCCESS_BUTTON: 'Continue to Dashboard',
};

// Field placeholders
export const AUTH_PLACEHOLDERS = {
  EMAIL: 'Enter your email',
  PASSWORD: 'Enter your password',
  FIRST_NAME: 'Enter first name',
  LAST_NAME: 'Enter last name',
  CONFIRM_PASSWORD: 'Re-enter your password',
  OTP_DIGIT: '',
  TFA_DIGIT: '',
};

// Field labels with required asterisk
export const AUTH_LABELS = {
  EMAIL_REQUIRED: (label: string) => `${label} *`,
  OPTIONAL: (label: string) => label,
};

// Timer and countdown
export const AUTH_TIMER = {
  OTP_COUNTDOWN_SECONDS: 60,
  OTP_RESEND_FORMAT: (seconds: number) => `Resend in ${seconds.toString().padStart(2, '0')}s`,
};

// External links
export const AUTH_LINKS = {
  TERMS_2290: 'https://www.2290.ai/terms-conditions',
  TERMS_TAX1099: 'https://www.tax1099.com/saas-terms-and-conditions',
  PRIVACY_2290: 'https://www.2290.ai/privacy-policy',
  PRIVACY_TAX1099: 'https://www.tax1099.com/privacy',
};

